/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectGroupSharing,
    ReadOnlyMonitoredObjectGroupSharingFromJSON,
    ReadOnlyMonitoredObjectGroupSharingFromJSONTyped,
    ReadOnlyMonitoredObjectGroupSharingToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20021
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20021
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20021
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectGroupSharing>}
     * @memberof InlineResponse20021
     */
    results: Array<ReadOnlyMonitoredObjectGroupSharing>;
}

export function InlineResponse20021FromJSON(json: any): InlineResponse20021 {
    return InlineResponse20021FromJSONTyped(json, false);
}

export function InlineResponse20021FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20021 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectGroupSharingFromJSON)),
    };
}

export function InlineResponse20021ToJSON(value?: InlineResponse20021 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectGroupSharingToJSON)),
    };
}


